<template>
  <iSignalStrength :level="level" />
</template>

<script>
const KNOWN_LEVELS = ["excellent", "good", "medium", "poor", "lost"];

// Anything unrecognised maps to `unknown`, which renders nothing rather than
// claiming a problem on the first frame after joining.
export default {
  name: "ConnectionIndicator",
  props: {
    quality: {
      type: String,
      default: "good",
    },
  },
  computed: {
    level() {
      return KNOWN_LEVELS.includes(this.quality) ? this.quality : "unknown";
    },
  },
};
</script>
